import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#0a0c0e',
      padding: '20px'
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        {/* Кнопка назад */}
        <Button
          onClick={handleBack}
          style={{
            background: 'transparent',
            color: '#e8e8e8',
            border: '2px solid #1a472a',
            marginBottom: '30px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          icon={<ArrowLeftOutlined />}
        >
          Назад
        </Button>

        {/* Заголовок */}
        <h1 style={{
          color: '#e8e8e8',
          fontSize: '28px',
          fontWeight: '700',
          marginBottom: '30px',
          textAlign: 'center'
        }}>
          Политика конфиденциальности
        </h1>

        {/* Контент */}
        <div style={{
          background: '#0f1113',
          border: '2px solid #1a472a',
          borderRadius: '12px',
          padding: '30px',
          color: '#e8e8e8',
          lineHeight: '1.6'
        }}>
          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            1. Общие положения
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Настоящая Политика конфиденциальности определяет порядок обработки 
            персональных данных пользователей сервиса LimitVerify (далее — «Сервис»).
          </p>

          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            2. Сбор персональных данных
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Мы собираем следующие категории персональных данных:
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li>Имя и фамилия</li>
            <li>Адрес электронной почты</li>
            <li>Данные о проверяемых изделиях</li>
            <li>Техническая информация (IP-адрес, тип браузера)</li>
          </ul>

          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            3. Цели обработки данных
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Персональные данные обрабатываются для:
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li>Предоставления услуг проверки подлинности</li>
            <li>Создания и управления личными кабинетами</li>
            <li>Улучшения качества сервиса</li>
            <li>Соблюдения требований законодательства</li>
          </ul>

          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            4. Защита данных
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Мы применяем современные технические и организационные меры для защиты 
            персональных данных от несанкционированного доступа, изменения, 
            раскрытия или уничтожения.
          </p>

          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            5. Передача данных третьим лицам
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Мы не передаем персональные данные третьим лицам без согласия пользователя, 
            за исключением случаев, предусмотренных законодательством.
          </p>

          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            6. Права пользователей
          </h2>
          <p style={{ marginBottom: '20px' }}>
            Пользователи имеют право на:
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li>Доступ к своим персональным данным</li>
            <li>Исправление неточных данных</li>
            <li>Удаление персональных данных</li>
            <li>Ограничение обработки данных</li>
            <li>Портабельность данных</li>
          </ul>

          <h2 style={{ color: '#1a472a', marginBottom: '20px' }}>
            7. Контактная информация
          </h2>
          <p style={{ marginBottom: '20px' }}>
            По вопросам обработки персональных данных обращайтесь по адресу: 
            privacy@limitverify.ru
          </p>

          <div style={{
            marginTop: '30px',
            padding: '20px',
            background: '#0a0c0e',
            borderRadius: '8px',
            border: '1px solid #1a472a'
          }}>
            <p style={{ margin: 0, fontSize: '14px', color: '#b5b9bf' }}>
              <strong>Дата последнего обновления:</strong> {new Date().toLocaleDateString('ru-RU')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
